import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1.5rem;
`;

export const emptyList = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${color.interface.white};
	border-radius: 5px;

	> p {
		font-size: 1.5rem;
		font-family: nunito-bold;
		color: ${color.interface.lightGray};
	}
`;

export const list = styled.div`
	width: 100%;
	overflow: auto;
	display: flex;
	gap: 1.5rem;
	align-items: flex-start;
	justify-content: flex-start;
	flex-wrap: wrap;
`;

export const item = styled.div`
	position: relative;
	border-radius: 5px;
	background-color: ${color.interface.white};

	> svg {
		color: ${color.interface.lightGray};
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 2rem;
		transition: all ease 0.5s;
		cursor: pointer;

		&:hover {
			transform: scale(1.1);
		}
	}
`;

export const content = styled.div`
	width: auto;
	padding: 2rem;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	border: 1px solid ${color.interface.lightGray3};
	cursor: pointer;
	border-radius: 5px;

	p {
		width: 100%;
		font-size: 1.4rem;
		font-family: nunito-bold;
		color: ${color.interface.darkgray3};
		text-align: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	img {
		width: 15rem;
		height: 15rem;
		border-radius: 5px;
		object-fit: contain;
	}
`;

export const messageDelete = styled.div`
	width: 100%;
	display: flex;
	gap: 0.5rem;
	align-items: center;
	justify-content: center;

	> p {
		font-size: 1.3rem;
	}
`;
